import { PAGE_VARIATIONS, TAB_OPTIONS } from '../constants';
import { useListDetailsContext } from '../contexts/listDetails';

export const useGetTabOptions = (): TAB_OPTIONS[] => {
  const { pageVariation } = useListDetailsContext();
  if (pageVariation === PAGE_VARIATIONS.SEGMENTATION) {
    return [TAB_OPTIONS.USERS];
  } else {
    return Object.values(TAB_OPTIONS);
  }
};
